import { render, staticRenderFns } from "./HistoricoTecnico.vue?vue&type=template&id=028b8452&scoped=true&"
import script from "./HistoricoTecnico.vue?vue&type=script&lang=ts&"
export * from "./HistoricoTecnico.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricoTecnico.vue?vue&type=style&index=0&id=028b8452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b8452",
  null
  
)

export default component.exports